import styled, { css } from 'styled-components';

import { fontFamily } from 'stylesheet';

const LYRICS_CONTAINER_VERTICAL_PADDING_IN_PERCENT = 17;

// Elements displayed inside the mp3KbpPlayer
// must be resized proportionally to the videoArea.
// We define here their sizes as a ratio to the
// height of the videoArea.
export const SIZING_FACTORS = {
  lyricsFontSize: 1 / 11,
  cursorAreaWidth: 0.15,
  cursorAreaRightSpacing: 0.006,
};

interface LyricsContainerProps {
  isVisible: boolean;
}

export const LyricsContainer = styled.div<LyricsContainerProps>`
  ${({ isVisible }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: ${isVisible ? 'visible' : 'hidden'};
    overflow: hidden;
  `}
`;
LyricsContainer.displayName = 'LyricsContainer';

interface LyricsContentProps {
  fontSize: number;
  letterSpacing: number;
}

export const LyricsContent = styled.div<LyricsContentProps>`
  position: relative;
  width: 100%;
  height: ${100 - 2 * LYRICS_CONTAINER_VERTICAL_PADDING_IN_PERCENT}%;
  font-family: ${fontFamily.lyrics};
  ${({ fontSize, letterSpacing }) => css`
    font-size: ${fontSize}px;
    letter-spacing: ${letterSpacing}px;
  `}
`;
LyricsContent.displayName = 'LyricsContent';
